<template>
    <div class="points-management">
        <div class="page-header">
            <h2>{{ $t('pointsManagement.pageTitle') }}</h2>
        </div>

        <div class="content-wrapper">
            <PointsList :points-list="pointsList" :total="total" :loading="loading" :selected-point-id="selectedPointId"
                @search="handleSearch" @add="openAddPointDialog" @edit="openEditPointDialog" @delete="loadPointsData"
                @select="handleSelectPoint" @bind-vehicle="openBindVehicleDialog" style="width: 60%;" />
            <PointsMap ref="pointsMap" :points-list="pointsList" :selected-point-id="selectedPointId"
                @select-point="handleSelectPoint" style="width: 40%;" />
        </div>

        <PointEditDialog :visible.sync="pointDialogVisible" :point="currentPoint" :points-list="pointsList"
            @save="handleSavePoint" />

        <VehicleBindDialog :visible.sync="bindVehicleDialogVisible" :point="currentBindPoint"
            @update="loadPointsData" />
    </div>
</template>

<script>
import { queryPointsInfo } from '@/http/vehicle';
import PointsList from './components/PointsList.vue';
import PointsMap from './components/PointsMap.vue';
import PointEditDialog from './components/PointEditDialog.vue';
import VehicleBindDialog from './components/VehicleBindDialog.vue';

export default {
    name: 'PointsManagement',
    components: {
        PointsList,
        PointsMap,
        PointEditDialog,
        VehicleBindDialog
    },
    data() {
        return {
            loading: false,
            pointsList: [],
            total: 0,
            selectedPointId: null,
            currentPoint: this.getEmptyPoint(),
            currentBindPoint: null,
            pointDialogVisible: false,
            bindVehicleDialogVisible: false
        };
    },
    mounted() {
        this.loadPointsData();
    },
    methods: {
        loadPointsData(params = {}) {
            this.loading = true;
            const { keyword = '', page = 1, size = 10 } = params;

            queryPointsInfo({
                PageNo: page,
                PageSize: size,
                PointName: keyword
            }).then(res => {
                if (res.code === 200) {
                    this.pointsList = res.data || [];
                    this.total = res.recordsTotal || 0;
                }
                this.loading = false;
            }).catch(err => {
                this.loading = false;
            });
        },
        handleSearch(params) {
            this.loadPointsData(params);
        },
        handleSelectPoint(point) {
            this.selectedPointId = point.WayPointID;
            if (this.$refs.pointsMap && point.Longitude && point.Latitude) {
                const lng = parseFloat(point.Longitude);
                const lat = parseFloat(point.Latitude);
                this.$refs.pointsMap.setCenter(lng, lat);
            }
        },
        openAddPointDialog() {
            this.currentPoint = this.getEmptyPoint();
            this.pointDialogVisible = true;
        },
        openEditPointDialog(point) {
            this.currentPoint = { ...point };
            this.selectedPointId = point.WayPointID;
            this.pointDialogVisible = true;
        },
        closePointDialog() {
            this.pointDialogVisible = false;
        },
        handleSavePoint() {
            this.pointDialogVisible = false;
            this.loadPointsData();
        },
        openBindVehicleDialog(point) {
            console.log(point);
            this.currentBindPoint = { ...point };
            this.bindVehicleDialogVisible = true;
        },
        getEmptyPoint() {
            return {
                WayPointID: 0,
                WayPointName: '',
                Longitude: '',
                Latitude: '',
                Remark: '',
                RangeRadius: 200,
                MaxLeaveTime: 15,
                IsEnabled: 1,
                BoundVehicles: []
            };
        }
    }
};
</script>

<style scoped>
.points-management {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.page-header h2 {
    margin: 0;
}

.content-wrapper {
    display: flex;
    height: calc(100% - 20px);
    gap: 16px;
}

@media (max-width: 1200px) {
    .content-wrapper {
        flex-direction: column;
        height: auto;
    }
}
</style>

<style>
.points-management .el-card__header {
    padding: 10px 20px;
}
</style>